module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBold.5076adf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.ttf
// module id = Ka0G
// module chunks = 16